// extracted by mini-css-extract-plugin
module.exports = {"new-patient-container":"NewPatient_new-patient-container__3YBaM","personal-info-container":"NewPatient_personal-info-container__1IxPH","background":"NewPatient_background__AM9zB"};